import { Record } from "../../components/record/Record";
import { Records } from "../../components/records/Records";
import { tabs } from "./clinicsNfbCapacityBlocksTabs";
import { EntityForm } from "../../components/entityForm/EntityForm";
import { Groups } from "../../components/groups/Groups";
import { DetailTabs } from "../../components/detailTabs/DetailTabs";
import { clinicsNfbCapacityBlocksOptions, clinicsNfbCapacityBlocksRecordOptions } from "./clinicsNfbCapacityBlocksOptions";
import { ClinicNfbCapacityHeader } from "./ClinicNfbCapacityHeader";

export const fieldsQuery = "*.*";

export const clinicsNfbCapacityBlocksRoutes = [
    {
        path: "/clinics_nfb_capacity_blocks",
        element: (
            <Records
                entity="clinics_nfb_capacity_blocks"
                fieldsQuery={fieldsQuery}
                options={clinicsNfbCapacityBlocksOptions}
                heightOfHeaders={190}
            />
        ),
    },
    {
        path: "/clinics_nfb_capacity_blocks/:id",
        element: (
            <Record
                entity="clinics_nfb_capacity_blocks"
                type="detail"
                fieldsQuery={fieldsQuery}
                options={clinicsNfbCapacityBlocksRecordOptions}
                header={<ClinicNfbCapacityHeader />}
                body={<DetailTabs tabs={tabs} />}
            />
        ),
        children: [
            {
                path: "/clinics_nfb_capacity_blocks/:id/detail",
                element: <Groups />,
            },
        ],
    },
    {
        path: "/clinics_nfb_capacity_blocks/:id/update",
        element: (
            <Record
                entity="clinics_nfb_capacity_blocks"
                type="update"
                options={clinicsNfbCapacityBlocksRecordOptions}
                header={<ClinicNfbCapacityHeader />}
                body={<EntityForm groupsOptions={clinicsNfbCapacityBlocksOptions?.groupsOptions} />}
            />
        ),
    },
    {
        path: "/clinics_nfb_capacity_blocks/create",
        element: (
            <Record
                entity="clinics_nfb_capacity_blocks"
                type="create"
                options={clinicsNfbCapacityBlocksRecordOptions}
                header={<ClinicNfbCapacityHeader />}
                body={<EntityForm groupsOptions={clinicsNfbCapacityBlocksOptions?.groupsOptions} />}
            />
        ),
    },
];
